// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { fontSizeSmall } from '@atlaskit/theme/constants';
import { N800, N30, N20 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PreviewWrapper = styled.div({
	minWidth: '320px',
	marginTop: token('space.200', '16px'),
	boxShadow: token(
		'elevation.shadow.overlay',
		`0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31)`,
	),
	borderRadius: '4px',
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TopBar = styled.div({
	display: 'flex',
	padding: token('space.100', '8px'),
	borderRadius: '4px 4px 0 0',
	backgroundColor: token('color.background.neutral.bold', N800),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TopBarDot = styled.div({
	backgroundColor: token('color.icon.inverse', '#fff'),
	marginRight: token('space.050', '4px'),
	width: '6px',
	height: '6px',
	borderRadius: '50%',
});

const TERMS_AND_CONDITIONS_ALLOWANCE = '88px';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Content = styled.div<{ shouldDisplayTermsAndConditions: boolean }>({
	minHeight: '346px',
	overflowY: 'scroll',
	height: `calc( 100vh - 297px - ${TERMS_AND_CONDITIONS_ALLOWANCE} )` /* consume most of the remaining space taking into account nav, title, margins etc */,
	maxHeight: '800px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BottomBar = styled.div({
	padding: `${token('space.100', '8px')} ${token('space.150', '12px')}`,
	borderTop: `1px solid ${token('color.border', N30)}`,
	borderRadius: '0 0 4px 4px',
	backgroundColor: token('color.background.neutral', N20),
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PreviewTeaser = styled.p({
	fontSize: `${fontSizeSmall()}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PoweredByWrapper = styled.div({
	flex: '1 1 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TermsAndPrivacyWrapper = styled.div({
	paddingTop: token('space.300', '24px'),
	paddingBottom: token('space.300', '24px'),
	textAlign: 'center',
});
